import {Component, Input, OnInit} from '@angular/core';
import {DInDescription} from "../../digitalin/digitalInDescription";
import {DIState} from "../../digitalin/digitalInStatus";
import {DigitalinlistComponent} from "../../digitalin/digitalinlist/digitalinlist.component";
import {DOState} from "../digitalOutStatus";
import {DOutDescription} from "../digitalOutDescription";
import {DigitaloutlistComponent} from "../digtaloutlist/digitaloutlist.component";

@Component({
  selector: 'app-digitaloutdetails',
  templateUrl: './digitaloutdetails.component.html',
  styleUrls: ['./digitaloutdetails.component.css']
})
export class DigitaloutdetailsComponent implements OnInit {

  @Input()
  refNumber: number = -1;
  checked: boolean = false;
  doDescription: DOutDescription;
  doStatus: DOState;

  constructor(private digitaloutlistComponent: DigitaloutlistComponent) {
    this.doDescription = new DOutDescription();
    this.doStatus = new DOState();
    this.checked = false;
    digitaloutlistComponent.Add(this);
  }

  UpdateLayoutData(doDescription: DOutDescription): void
  {
    this.doDescription = doDescription;
  }
  UpdateDoState(doState: DOState): void
  {
    this.doStatus = doState;
    this.checked = (this.doStatus.value) ? true :false;
  }

  ngOnInit(): void {
  }


}
